import type { Maybe, ValueEvent } from '@adornis/base/utilTypes.js';
import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import { WindowSizeController } from '@adornis/chemistry/controllers/window-size-controller.js';
import { css } from '@adornis/chemistry/directives/css.js';
import '@chancenwerk/client/components/chancen-component-card-title.js';
import '@chancenwerk/work-tracking/client/chancen-component-work-tracking.js';
import { html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import '../components/campus-component-teacher-dashboard-lesson-list.js';
import './campus-page-no-permission.js';

@customElement('campus-page-work-tracking')
export class CampusPageWorkTracking extends ChemistryLitElement {
  @property() eid = new RXController<Maybe<string>>(this, null);

  @state() private _title = 'Tätigkeit';
  @state() private readonly size = new WindowSizeController(this);

  override styles = () => [
    {
      ':host': {
        // height: '100%',
        width: '100%',
      },
    },
  ];

  override render() {
    return this._content();
  }

  private _content() {
    return html`
      <cr-flex padding="${this.size.mobile ? 'md' : 'lg'}" space="lg">
        <cr-flex space="lg">
          <cr-h2> ${this._title} </cr-h2>
        </cr-flex>

        <chancen-component-work-tracking
          .eid=${this.eid.value}
          @title-change=${(e: ValueEvent<string>) => (this._title = e.detail.value)}
        ></chancen-component-work-tracking>

        <cr-flex w100 ${css({ height: '100px' })}></cr-flex>
      </cr-flex>
    `;
  }
}
